import { defineFcm } from '../shared/factory';

export const FCM_PRIVACY_HIDE_RECRUITER = defineFcm('privacy_hide_recruiter').asBoolean().withDefault(false).toConfig();
